var _ellipse, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 118,
    viewBox: "0 0 104 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5,
    cy: 110.657,
    rx: 39.5,
    ry: 6.5,
    fill: "#434D56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8229 84.8228L27.978 102.466L30.9292 12.3726L46.2203 8.27535L93.8229 84.8228Z",
    fill: "#FBDB98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4269 83.3223L22.3477 103.976L24.9398 113.65L102.019 92.9962L99.4269 83.3223Z",
    fill: "#FBDB98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 79.8872L27.9812 102.468L93.8261 84.8245L81.9826 65.5888L28.6201 79.8872Z",
    fill: "#E19A06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.239 57.3066L69.807 46.4364L57.9635 27.2006L30.1899 34.6425L29.239 57.3066Z",
    fill: "#E19A06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.5d989f8c74f1ca9dfc1bd8006e63cf4b.svg";
export { ForwardRef as ReactComponent };